<app-uri-handler></app-uri-handler>
<router-outlet></router-outlet>
<app-buy></app-buy>
<app-buy-modal></app-buy-modal>